import {
  CateringStatusType,
  DestinationSystemType,
  type NonAttendanceApplicationDetail,
} from '@/components/AbsenceApplication/types';
import { formatDateRange, isSameApiDate } from '@/utils/date';

export enum AbsenceStateMode {
  Result = 'result',
  Detail = 'detail',
}

interface State {
  absenceLabel: string;
  cateringLabel: string;
  isRiga: boolean;
  isCancellationError: boolean;
  showCateringDivider: boolean;
  showCateringPreserved: boolean;
  showCateringSuccess: boolean;
  showCateringCanceled: boolean;
  showRetry: boolean;
  showSentTo: boolean;
  periodsMatch: boolean;
}

export const useAbsenceState = (
  application: NonAttendanceApplicationDetail,
  mode: AbsenceStateMode = AbsenceStateMode.Detail,
): State => {
  const { absencePeriod, cateringRequest } = application;
  const isCateringCanceled = cateringRequest?.isCateringCanceled ?? false;
  const isRiga =
    cateringRequest?.destinationSystemType === DestinationSystemType.Riga;
  const isCancellationError =
    isCateringCanceled &&
    cateringRequest?.statusType === CateringStatusType.Error;
  const absenceLabel = formatDateRange(absencePeriod.from, absencePeriod.to);
  const cateringLabel = cateringRequest
    ? formatDateRange(
        cateringRequest.cateringPeriod.from,
        cateringRequest.cateringPeriod.to,
      )
    : '';
  const periodsMatch =
    !!cateringRequest &&
    isSameApiDate(absencePeriod.from, cateringRequest.cateringPeriod.from) &&
    isSameApiDate(absencePeriod.to, cateringRequest.cateringPeriod.to);
  const isResultMode = mode === AbsenceStateMode.Result;

  return {
    absenceLabel,
    cateringLabel,
    isRiga,
    isCancellationError,
    showCateringDivider: !!cateringRequest,
    showCateringPreserved: !!cateringRequest && !isCateringCanceled,
    showCateringSuccess: isCateringCanceled && !isCancellationError,
    showCateringCanceled: !!cateringRequest && isCateringCanceled,
    showRetry: isResultMode
      ? isCancellationError && isRiga
      : isCancellationError,
    showSentTo: isResultMode
      ? isCateringCanceled &&
        cateringRequest?.destinationSystemType !== DestinationSystemType.None
      : !!cateringRequest &&
        cateringRequest.destinationSystemType !== DestinationSystemType.None,
    periodsMatch,
  };
};
